import { fixResponseJSON, filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const potentialClientsService = {
  getPotentialClients: async (body) => {
    const response = await authInstance
      .post(`${url}/potentialClients/list?`, body)
      .then(async (response) => {
        return response;
      });
    return response;
  },

  createPCBatch: async (file) => {
    const myInit = {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'POST',
      body: file,
    };

    const response = await fetch(`${url}/potentialClients/create`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updatePotentialClients: async (id, body) => {
    const response = await authInstance
      .put(`${url}/potentialClients/update/${id}`, body)
      .then(async (response) => {
        return response;
      });
    return response;
  },
};
